<template>
  <ul class="flex justify-between gap-2 mt-8">
    <li class="flex flex-col items-center gap-2">
      <a
        href="#"
        :disabled="inProgress"
        @click.prevent.stop="() => emitAction(AuthActions.GOOGLE)"
        data-testid="sign-in-google"
        class="flex items-center justify-center px-3 font-bold text-black whitespace-pre bg-transparent border rounded-10 w-14 h-14 dark:text-zinc-300 border-slate-200 dark:border-zinc-500 hover:bg-slate-200 dark:hover:bg-zinc-700 sm:px-4 sm:text-sm"
      >
        <Icon name="social.google" size="base" />
        <span class="sr-only dark:text-zinc-300">Sign in with Google</span>
      </a>
      <span aria-hidden="true" class="text-sm font-semibold dark:text-zinc-300">Google</span>
    </li>
    <li class="flex flex-col items-center gap-2">
      <a
        href="#"
        :disabled="inProgress"
        @click.prevent.stop="() => emitAction(AuthActions.APPLE)"
        data-testid="sign-in-apple"
        class="flex items-center justify-center px-3 font-bold text-black whitespace-pre bg-transparent border rounded-10 w-14 h-14 dark:text-zinc-300 border-slate-200 dark:border-zinc-500 hover:bg-slate-200 dark:hover:bg-zinc-700 sm:px-4 sm:text-sm"
      >
        <Icon name="social.apple" size="base" />
        <span class="sr-only dark:text-zinc-300">Sign in with Apple</span>
      </a>
      <span aria-hidden="true" class="text-sm font-semibold dark:text-zinc-300">Apple</span>
    </li>

    <li v-if="isSlackEnabled" class="flex flex-col items-center gap-2">
      <a
        href="#"
        :disabled="inProgress"
        @click.prevent.stop="() => emitAction(AuthActions.SLACK)"
        data-testid="sign-in-slack"
        class="flex items-center justify-center px-3 font-bold text-black whitespace-pre bg-transparent border rounded-10 w-14 h-14 dark:text-zinc-300 border-slate-200 dark:border-zinc-500 hover:bg-slate-200 dark:hover:bg-zinc-700 sm:px-4 sm:text-sm"
      >
        <Icon name="social.slack" size="base" />
        <span class="sr-only">Sign in with Slack</span>
      </a>
      <span aria-hidden="true" class="text-sm font-semibold">Slack</span>
    </li>

    <li class="flex flex-col items-center gap-2">
      <a
        :disabled="inProgress"
        @click.prevent.stop="() => emitAction(AuthActions.SSO)"
        data-testid="sign-in-sso"
        href="#"
        class="flex items-center justify-center px-3 font-bold text-black whitespace-pre bg-transparent border rounded-10 w-14 h-14 dark:text-zinc-300 border-slate-200 dark:border-zinc-500 hover:bg-slate-200 dark:hover:bg-zinc-700 sm:px-4 sm:text-sm"
      >
        <Icon name="social.sso" size="base" />
        <span class="sr-only dark:text-zinc-300">Sign in with SSO</span>
      </a>
      <span aria-hidden="true" class="text-sm font-semibold dark:text-zinc-300">SSO</span>
    </li>
    <li class="flex flex-col items-center gap-2" v-if="showEmail">
      <a
        :disabled="inProgress"
        data-testid="sign-in-email"
        @click.prevent.stop="() => emitAction(AuthActions.EMAIL)"
        href="#"
        class="flex items-center justify-center px-3 font-bold text-black whitespace-pre bg-transparent border rounded-10 w-14 h-14 dark:text-zinc-300 border-slate-200 dark:border-zinc-500 hover:bg-slate-200 dark:hover:bg-zinc-700 sm:px-4 sm:text-sm"
      >
        <Icon name="general.at" size="base" />
        <span class="sr-only dark:text-zinc-300">Sign in with Email</span>
      </a>
      <span aria-hidden="true" class="text-sm font-semibold dark:text-zinc-300">Email</span>
    </li>
  </ul>
</template>
<script setup lang="ts">
import { AuthActions } from '@/composables/useAuth';
import { useFeatures } from '@/composables/useFeatures';
import { Icon } from '@/storybook/icon';

defineProps<{
  redirectUrl?: string;
  showEmail?: boolean;
  inProgress?: boolean;
}>();

const emits = defineEmits<{
  (e: 'action', value: AuthActions): void;
}>();

const emitAction = (value: AuthActions) => emits('action', value);

const { getFeature } = useFeatures();
const isSlackEnabled = getFeature('web-show-slack-sign-button');
</script>
